import { Link } from 'react-router';

interface PublicFooterProps {
  showCompanyDetails?: boolean;
}

export default function PublicFooter({ showCompanyDetails = false }: PublicFooterProps) {
  return (
    <footer className={`public-footer${showCompanyDetails ? ' public-footer--with-company' : ''}`}>
      {showCompanyDetails ? (
        <div className="public-footer-company">
          <ul>
            <li><strong>AI-kuja</strong></li>
            <li>CVR: 46690494</li>
            <li>Sallingelunde 8, 5750 Ringe</li>
          </ul>
        </div>
      ) : null}
      <nav aria-label="Sidefod">
        <Link className="public-footer-link" to="/privatlivspolitik">
          Privatlivspolitik
        </Link>
      </nav>
    </footer>
  );
}
